import { useCallback } from 'react';

import {
  ConditionsReactivateJuridictionDto,
  ReferentielUsesDto,
} from 'lib_api/lib/api/gen';

import { useApi } from 'hooks/ApiStoreContext';

import { UseActivationJuridictionReturn } from '../types';

export function useActivationJuridiction(): UseActivationJuridictionReturn {
  const controller = useApi().AdminFonctionnelControllerApi;

  const submitDeprecate = useCallback(
    (idCorrelation: string): Promise<Response> => {
      return controller.deprecateJuridictionUsingPUT(idCorrelation);
    },
    [controller],
  );

  const submitReactivate = useCallback(
    (idCorrelation: string): Promise<Response> => {
      return controller.reactivateJuridictionUsingPUT(idCorrelation);
    },
    [controller],
  );

  const conditionsReactivate = useCallback(
    (idCorrelation: string): Promise<ConditionsReactivateJuridictionDto> => {
      return controller.conditionReactivationJuridictionUsingGET(idCorrelation);
    },
    [controller],
  );

  const getUsesJuridiction = useCallback(
    (idCorrelation: string): Promise<ReferentielUsesDto> => {
      return controller.searchUsesJuridictionUsingGET(idCorrelation);
    },
    [controller],
  );

  return {
    submitReactivate,
    submitDeprecate,
    conditionsReactivate,
    getUsesJuridiction,
  };
}
